import {DndContext} from '@dnd-kit/core';
import {SortableContext, rectSortingStrategy} from '@dnd-kit/sortable';
import {ImageFile, ImageType} from '../../model';
import {FundraiserImageWithMenu} from '../FundraiserImageWithMenu';
import {ImageUploadButton} from '../ImageUploadButton';
import styles from './ImagesList.module.scss';

interface ImagesListProps {
  images: ImageFile[];
  imageType: ImageType;
  fundraiserId?: string;
  isDragDisabled: boolean;
  sensors: any;
  collisionDetection: any;
  onDragEnd: (event: any) => void;
  onImageView: (url: string, fileName: string, allImages: ImageFile[]) => void;
  onImageDelete: (imageType: ImageType, fileName: string) => Promise<void>;
  onUploadSuccess: () => void;
  onUploadNewImage?: (imageType: ImageType) => void;
  aspectRatio?: number;
}

export const ImagesList = ({
  images,
  imageType,
  fundraiserId,
  isDragDisabled,
  sensors,
  collisionDetection,
  onDragEnd,
  onImageView,
  onImageDelete,
  onUploadSuccess,
  onUploadNewImage,
  aspectRatio,
}: ImagesListProps) => {
  if (images.length === 0) {
    return (
      <div className={styles.emptyContainer}>
        <ImageUploadButton
          aspectRatio={aspectRatio}
          imageType={imageType}
          fundraiserId={fundraiserId}
          onUploadSuccess={onUploadSuccess}
        />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <DndContext sensors={sensors} collisionDetection={collisionDetection} onDragEnd={onDragEnd}>
        <SortableContext items={images.map((img) => img.fileName)} strategy={rectSortingStrategy}>
          <div className={styles.imagesGrid}>
            {images.map((image) => (
              <FundraiserImageWithMenu
                key={image.fileName}
                image={image}
                imageType={imageType}
                allImages={images}
                openImageViewer={onImageView}
                handleDeleteImage={onImageDelete}
                handleUploadNewImage={onUploadNewImage}
                isDragDisabled={isDragDisabled}
                aspectRatio={aspectRatio}
              />
            ))}
          </div>
        </SortableContext>
      </DndContext>

      {imageType !== ImageType.AVATAR && (
        <>
          <ImageUploadButton
            aspectRatio={aspectRatio}
            imageType={imageType}
            fundraiserId={fundraiserId}
            onUploadSuccess={onUploadSuccess}
          />
        </>
      )}
    </div>
  );
};
